// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
import AutomatedTools from "./AutomatedTools-APP_CLIENT.styled";
export default AutomatedTools;
